import { createSelector } from '@ngrx/store';
import { AnalyticsConsentDialogState } from './analytics-consent-dialog.state';
import { selectDialogs } from '../../+store';

/**
 * Selectors für den Analytics-Consent-Dialog.
 */
export class AnalyticsConsentDialogSelectors {
  private static readonly _slice = createSelector(
    selectDialogs,
    (state): AnalyticsConsentDialogState => state.analyticsConsentDialog,
  );

  /**
   * Selector für den isOpen-Status.
   */
  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );
}
